<template>
    <div>
        <div class="stbg">
            <img src="../../assets/images/qyh01.jpg"> 
        </div>
        <div class="stforms">
          <div class="sttit">
                <img src="../../assets/images/qyh02.png"> 
          </div>
          
          <div class="stipts">
              <div class="stipt">
                 <div class="stipt-img">
                     <img src="../../assets/images/f6.png">
                 </div>
                <input class="stipt-ipt" 
                           v-model.trim="model.userNameOrEmailAddress" ref="ipt1" placeholder="请输入用户名" @blur="iptfx" type="number">
              </div>
              <div class="stipt">
                 <div class="stipt-img">
                     <img src="../../assets/images/f5.png">
                 </div>
                <input class="stipt-ipt" 
                          v-model.trim="model.password" type="password" ref="ipt2" placeholder="请输入密码" @blur="iptfx">
              </div>
              <div class="stxy" v-if="moreappconst&&moreappconst.isEnableAgree">
                 <span class="stxy-left"><van-checkbox v-model="checked" shape="square" :checked-color="color" icon-size="14px" >同意协议</van-checkbox></span>
                 <span class="stxy-right" @click="showxy=true">查看协议</span>
                 <div class="clearboth"></div>
              </div>
              <div class="stbtnc">
                  <button @click="login">登录</button>
                  <button @click="wxlogin" >微信授权</button>
              </div>
          </div>
          
        </div>

        <div class="stfooter">
             <span>好用又实惠,就选群婴汇</span>
        </div>
        <div class="stbgcolor">

        </div>
        
        <!-- <div class="stfooter">
              <div>贝<span class="stfooter-d">·</span>优趣<span>|</span>更<span class="stfooter-d">·</span>有趣</div>
        </div> -->
        <van-dialog
        v-model="showxy"
        title="协议"
        @confirm="showxy=false"
      >
        <div style="margin: 15px">
            <div v-html="moreappconst&&moreappconst.agreeContent"></div>
        </div>
      </van-dialog>

    </div>
</template>
<script>
import Util from "../../config/Util";
import appconst from "../../config/appconst";
export default {
    data(){
        return {
            showxy:false,
            color:'#666666',
            active: 0,
            model: {
                tenancyName: "default",
            },
            checked:false,
            parentcode: "",
            showparentcode: false,
            imgindex: 0,
            moreappconst:undefined
        }
    },
    beforeCreate() {
    this.imglogo=this.$baseurl+"/Temp/Downloads/loginbottomlogo.png";
    if (localStorage.getItem("wxlogin")) {
      var code = this.getQueryVariable("code");
      if (code) {
        let parentdguid = localStorage.getItem("parentdguid");
        localStorage.setItem("wxlogin", "");
        localStorage.setItem("parentdguid", "");
        this.ajax
          .post("/api/TokenAuth/WxOAuthorization", {
            code: code,
            parentDguid: parentdguid,
            levelId: 5,
            registMethod: 0,
          })
          .then((req) => {
            var tokenExpireDate = new Date(
              new Date().getTime() + 1000 * req.result.expireInSeconds
            );

            Util.abp.auth.setToken(req.result.accessToken, tokenExpireDate);
            Util.abp.utils.setCookieValue(
              appconst.authorization.encrptedAuthTokenName,
              req.result.encryptedAccessToken,
              tokenExpireDate,
              Util.abp.appPath
            );
            location.href = "http://" + location.host;
            return;
          });
        return;
      }
    }
  },
  created(){
        this.queryagreecontent();
  },
    methods:{
        queryagreecontent(){
          this.ajax
            .post(
              "/api/services/app/PhoneCom/QueryAgreeContentByUrl"
            ).then(x=>
            {
                this.moreappconst=x.result;
            })
        },
        iptfx(){
            setTimeout(function(){
                var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
                window.scrollTo(0, Math.max(scrollHeight - 1, 0));
            }, 100);
        },
        login() {
            //判断登陆模式
            if(!this.model.userNameOrEmailAddress)
            {
                 this.$toast.fail("请输入账号");
                 this.$refs.ipt1.focus();
                 return;
            }
            if(!this.model.password)
            {
                this.$toast.fail("请输入密码");
                this.$refs.ipt2.focus();
                return;
            }
            if(this.moreappconst.isEnableAgree&&this.checked==false)
            {
                this.$toast.fail("请先同意协议后,再登录");
                return;
            }
            
            this.ajax.post("/api/TokenAuth/Authenticate", this.model).then((req) => {
                //console.log(req);
                var tokenExpireDate = new Date(
                new Date().getTime() + 1000 * req.result.expireInSeconds
                );

                Util.abp.auth.setToken(req.result.accessToken, tokenExpireDate);
                Util.abp.utils.setCookieValue(
                appconst.authorization.encrptedAuthTokenName,
                req.result.encryptedAccessToken,
                tokenExpireDate,
                Util.abp.appPath
                );
                location.reload();
            });
        },
        wxlogin() {
      if (process.env.NODE_ENV == "production") {
        localStorage.setItem("wxlogin", "1");
        location.href =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
          appconst.wxappid +
          "&redirect_uri=http%3A%2F%2f" +
          location.host +
          "%2F%23%2Flogin%2Fpassword" +
          "&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect";
      }
    },
    fixScroll() {
      let u = navigator.userAgent;

      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

      if (isiOS) {
        window.scrollTo(0, 0);
      }
    },
    parentcodelogin() {
      if (!this.parentcode) {
        this.$toast.fail("授权码不能为空");
        return;
      }
      this.ajax
        .post(
          "/api/services/app/PhoneCom/QueryMemberInfoByMemberNo?memberNo=" +
            this.parentcode
        )
        .then((x) => {
          localStorage.setItem("parentdguid", x.result);
          this.wxlogin();
        });
    },
    initWx() {
      //微信配置初始化
      var isIOS = !!window.navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      let tmpurl = location.href;
      if (isIOS) {
        tmpurl = window.entryUrl;
      } else {
        tmpurl = window.location.href;
      }
      this.ajax
        .post("/api/services/app/PhoneCom/QueryH5Sign", { url: tmpurl })
        .then((y) => {
                var h5info = y.result;
                var wx = window.wx;
                wx.config({
                    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    appId: h5info.appid, // 必填，公众号的唯一标识
                    timestamp: h5info.timeStamp + "", // 必填，生成签名的时间戳
                    nonceStr: h5info.nonceStr, // 必填，生成签名的随机串
                    signature: h5info.sign, // 必填，签名
                    jsApiList: [
                    "updateAppMessageShareData",
                    "updateTimelineShareData",
                    "onMenuShareWeibo",
                    "scanQRCode",
                    ], // 必填，需要使用的JS接口列表
                });
                let link = "http://" + location.host;
                wx.ready(() => {
                    wx.updateAppMessageShareData({
                    title: this.abp.systemconfig.shareTitle, // 分享标题
                    desc: this.abp.systemconfig.shareDesc, // 分享描述
                    link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: this.$baseurl + this.abp.systemconfig.shareImg, // 分享图标
                    success: function (res) {
                        // 设置成功
                    },
                    fail: function (res) {
                        //alert(res);
                    },
                    });
                    wx.updateTimelineShareData({
                    title: this.abp.systemconfig.shareTitle, // 分享标题
                    link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: this.$baseurl + this.abp.systemconfig.shareImg, // 分享图标
                    success: function (res) {
                        // 设置成功
                    },
                    fail: function (res) {
                        //alert(res);
                    },
                    });
                });
                wx.error(function (res) {
                    //alert(res);
                    // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                });
            });
        },
    }
}
</script>

<style>
.stxy .van-checkbox__icon .van-icon{
    border: 1px solid #666666 !important;
}
.stxy .van-checkbox__label{
  color:#666666;
}
</style>
<style lang="scss" scoped>
.stbg{
    width: 100%;
    
}
.stbg img{
    width: 100%;
    height: auto;
}
.stforms{
  margin: 0px 35px;
  padding: 15px 20px 35px 20px;
  margin-top: -42vw;
  background-color: #afd9ba;
  font-size: 14px;
  position: relative;
  border-radius: 8px;
  box-shadow: 1px 1px 8px #d0d0d0;
}
.sttit{
  font-size: 24px;
  text-align: center;
  margin-bottom:15px;
  font-weight: 400;
}
.sttit img{
       width: 100px;
       height: auto;
  }

.stipt{
    position: relative;
    padding-left: 30px;
    height: 40px;
    border-bottom: 1px solid #ccc;
    background: #fff;
    border-radius: 6px;
}

.stipt:first-child
{
  margin-bottom: 25px;
}
.stipt-img{
  position: absolute;
  left: 5px;
  top:50%;
  transform: translate(0,-50%);
}
.stipt-img img{
  width: 20px;
  height: 20px;
}
.stipt-ipt{
    border: 0;
    padding: 0;
    margin: 0;
    background: none;
    width: 100%;
    font-size: 14px;
    line-height: 40px;
}

.stxy{
  font-size:12px;
  margin-top: 10px;
  color:#666666;
}

.stxy-left
{
  font-size: 14px;
  display: inline-block;
}
.stxy-right{
  display: inline;
  float:right;
}
.stbtnc{
  position: absolute;
  bottom: -20px;
  text-align: center;
  left: 0;
  right: 0;
}
.stbtnc button
{
    height: 40px;
    background: linear-gradient(to right, #81c291 0%, #93cfa4 25%, #84c595 50%, #bee1c8 100%);
    border: 0;
    border-radius: 28px;
    width: 120px;
    color: white;
    font-size: 18px;
    box-shadow: 1px 1px 4px #a8a8a8;
}
.stbtnc button:first-child{
  margin-right: 20px;
}
.stbgcolor{
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: #fff;
    z-index:-1;
}
.stfooter{
  margin-top: 50px;
  text-align: center;
  font-size: 14px;
  color: #85c56f;
  letter-spacing: 2px;
}
.stfooter span{
  padding: 5px 0;
  border-top:1px solid #85c56f;
  border-bottom: 1px solid #85c56f;
}
</style>